// import COMPANY_API from '@/api/masterData/company.js';
export const searchColumns = () => {
  return [
    {
      name: '调整结算数量',
      prop: 'adjustStatementQuantity',
      type: 'inputAmount',
      precision: 3,
      max: 999999999,
      changeMethod: 'changeMethod',
      span: 8,
    },
    {
      name: '调整结算单价(含税)',
      prop: 'adjustOriginalPrice',
      type: 'inputAmount',
      precision: 3,
      max: 999999999,
      min: -9999999,
      changeMethod: 'changeMethod',
      span: 8,
    },
    {
      name: '调整原币结算金额(含税)',
      prop: 'adjustOriginalAmount',
      type: 'input',
      // disabled: true,
      changeMethod: 'changeMethod',
      span: 8,
    },
    {
      name: '调整原因',
      prop: 'adjustReason',
      type: 'input',
      span: 24,
    },
  ];
};
export const tableRules = {
  adjustStatementQuantity: [{ required: true, message: '必填字段' }],
  adjustOriginalPrice: [{ required: true, message: '必填字段' }],
  adjustOriginalAmount: [{ required: true, message: '必填字段' }],
  adjustReason: [{ required: true, message: '必填字段' }],
};
